var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AppSettings } from 'app/app.settings';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT';
import { ActivityService } from './activity.service';
import { AppinfoService } from './appinfo.service';
import { ArchiveModeService } from './archive-mode.service';
import { AttrIndexService } from './attr-index.service';
import { CommonRequestService } from './common-request.service';
import { EditService } from './edit.service';
import { FieldMappingService } from './field-mapping.service';
import { GfoService } from './gfo.service';
import { GtoService } from './gto.service';
import { LayerQcService } from './layer-qc.service';
import { LayerService } from './layer.service';
import { MainDataService } from './main-data.service';
import { UserService } from './user.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-toastr";
import * as i2 from "./activity.service";
import * as i3 from "./appinfo.service";
import * as i4 from "./archive-mode.service";
import * as i5 from "./attr-index.service";
import * as i6 from "./common-request.service";
import * as i7 from "./edit.service";
import * as i8 from "./field-mapping.service";
import * as i9 from "./gfo.service";
import * as i10 from "./gto.service";
import * as i11 from "./layer.service";
import * as i12 from "./layer-qc.service";
import * as i13 from "./main-data.service";
import * as i14 from "./user.service";
// export interface ResoCenterEditCellEvent {
// 	changedCols: ResoCenterCol[];
// }
var ResolutionCenterService = /** @class */ (function () {
    function ResolutionCenterService(toastr, activityService, appinfoService, archiveModeService, attrIndexService, requestService, editService, fieldMappingService, gfoService, gtoService, layerService, qcService, mainDataService, userService) {
        this.toastr = toastr;
        this.activityService = activityService;
        this.appinfoService = appinfoService;
        this.archiveModeService = archiveModeService;
        this.attrIndexService = attrIndexService;
        this.requestService = requestService;
        this.editService = editService;
        this.fieldMappingService = fieldMappingService;
        this.gfoService = gfoService;
        this.gtoService = gtoService;
        this.layerService = layerService;
        this.qcService = qcService;
        this.mainDataService = mainDataService;
        this.userService = userService;
        this.resoFeedBS = new BehaviorSubject({
            record: null,
            feeds: null,
            recordId: null
        });
        this.fromAddrColCore = 'fromaddr'; // lower case
        this.toAddrColCore = 'toaddr'; // lower case
        this.drawAdditionalRcSubject = new Subject();
        this.recordsIndex = {};
        this.getDeltaValueByParity = function (currentValue, parity, direction) {
            if (parity !== 'E' && parity !== 'O') {
                return 1;
            }
            var valueParity = currentValue % 2 === 0 ? 'E' : 'O';
            var delta = valueParity === parity ? 2 : 1;
            if (direction === 'decrease') {
                delta = delta * -1;
            }
            return delta;
        };
    }
    // These two functions should only be used for commit / discard
    ResolutionCenterService.prototype.getRecordsIndex = function () {
        return this.recordsIndex;
    };
    ResolutionCenterService.prototype.setRecordsIndex = function (data) {
        this.recordsIndex = data;
    };
    ResolutionCenterService.prototype.getRecordInfo = function (id) {
        return this.recordsIndex[id] ? this.recordsIndex[id] : null;
    };
    ResolutionCenterService.prototype.addRecordInfoToStoredRecords = function (info, id) {
        if (!info) {
            return;
        }
        this.recordsIndex[id] = info;
    };
    ResolutionCenterService.prototype.setRecordAttrs = function (id, prop, val) {
        if (!this.recordsIndex[id]) {
            return;
        }
        this.recordsIndex[id].props[prop] = val;
    };
    ResolutionCenterService.prototype.setDataOriginAttrs = function (id, prop, val) {
        if (!this.recordsIndex[id]) {
            return;
        }
        this.recordsIndex[id].originalProps[prop] = val;
    };
    // This need to be done AFTER every record / related record's detail has been obtained
    ResolutionCenterService.prototype.setRelatedIds = function (feed) {
        var _this = this;
        if (feed) {
            var setIds_1 = function (ids) {
                ids.forEach(function (id) {
                    if (_this.recordsIndex[id]) {
                        _this.recordsIndex[id].relatedIdList = ids;
                    }
                });
            };
            Object.keys(feed.feed).forEach(function (cateCode) {
                var info = feed.feed[cateCode];
                if (info.list) {
                    var ids_1 = [info.id];
                    info.list.forEach(function (id) {
                        ids_1.push(id);
                    });
                    setIds_1(ids_1);
                }
            });
        }
    };
    ResolutionCenterService.prototype.getQaResolverFeeds = function (layerId, globalId, qaCodes) {
        var _this = this;
        // layerId = 1944;
        // globalId = '3716ca25-ddd1-4ca9-b1c3-ea5a89d919cb'; // '00002c90-8a77-45c4-9d6f-b5b94296381d';
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/rcFeedContentQa';
            var params = {
                layerId: layerId,
                globalId: globalId
            };
            if (qaCodes && qaCodes.length) {
                params.qaCodes = JSON.stringify(qaCodes);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var feeds = [];
                if (rsp.data && rsp.data[0]) {
                    feeds = rsp.data;
                }
                resolve(feeds);
            }, function (err) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, reject(err)];
            }); }); });
        });
    };
    ResolutionCenterService.prototype.getRecordsDetails = function (layerCateCode, ids) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var filteredIds, layer, idCol_1, idFilter, gfo, rsp, geomCol_1, geojsonFormat_1, wktFormat_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        filteredIds = ids.filter(function (id) { return !_this.recordsIndex[id]; });
                        if (!filteredIds.length) {
                            resolve([]);
                            return [2 /*return*/];
                        }
                        layer = this.activityService.displayedLayerListBS.getValue().layers.find(function (l) { return l.category.code === layerCateCode; });
                        idCol_1 = layer.category.colPrefix + '_' + this.attrIndexService.globalIdColLower;
                        idFilter = this.gfoService.getFilter(idCol_1, this.appinfoService.filterOperators.in.name, filteredIds);
                        gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [idFilter]);
                        return [4 /*yield*/, this.layerService.getLayerContents(layer.id, gfo)];
                    case 1:
                        rsp = _a.sent();
                        if (rsp.data) {
                            geomCol_1 = layer.category.colPrefix + '_' + this.attrIndexService.geomCol;
                            geojsonFormat_1 = new GeoJSON();
                            wktFormat_1 = new WKT();
                            rsp.data.forEach(function (data) {
                                var geomLength;
                                // store wkt geom
                                if (data[geomCol_1]) {
                                    var feat = geojsonFormat_1.readFeature(data[geomCol_1]);
                                    var wkt = wktFormat_1.writeGeometry(feat.getGeometry());
                                    data[_this.attrIndexService.geomColManual] = wkt;
                                    // Calc geom length for lines
                                    if (feat.getGeometry().getType() === 'LineString') {
                                        geomLength = feat.getGeometry().getLength();
                                    }
                                }
                                var rec = {
                                    props: data,
                                    originalProps: JSON.parse(JSON.stringify(data)),
                                    changedCols: [],
                                    cateCode: layerCateCode
                                };
                                if (geomLength || geomLength === 0) {
                                    rec.geomLength = geomLength;
                                }
                                _this.addRecordInfoToStoredRecords(rec, data[idCol_1]);
                                // this.records[data[idCol]] = rec;
                            });
                        }
                        resolve(rsp.data);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1);
                        reject(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        // return new Promise<any[]>(async (resolve, reject) => {
        // 	try {
        // 		const layerCate = this.appinfoService.layerTypeList.find(i => i.code === layerCateCode);
        // 		const idCol = layerCate.colPrefix + '_' + this.attrIndexService.globalIdColLower;
        // 		const idFilter = this.gfoService.getFilter(idCol, this.appinfoService.filterOperators.in.name, ids);
        // 		const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [idFilter]);
        // 		const rsp: any = await this.requestTableService.tableGet(layerCate.tableName, returnedCols.join(','), gfo, {
        // 			pageNumber: 0
        // 		});
        // 		resolve(rsp.data);
        // 	} catch (err) {
        // 		console.log(err);
        // 		reject(err);
        // 	}
        // })
    };
    ResolutionCenterService.prototype.getGlobalIdCol = function (layerCateCode) {
        var layerCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === layerCateCode; });
        return layerCate.colPrefix + '_' + this.attrIndexService.globalIdColLower;
    };
    ResolutionCenterService.prototype.transformCols = function (cols, layerCateCode) {
        return __awaiter(this, void 0, void 0, function () {
            var layerCate, stdSchema;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layerCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === layerCateCode; });
                        if (!layerCate) {
                            return [2 /*return*/, []];
                        }
                        if (!!layerCate.standardCols) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fieldMappingService.getStandardSchema(layerCate.id)];
                    case 1:
                        stdSchema = _a.sent();
                        layerCate.standardCols = stdSchema;
                        _a.label = 2;
                    case 2: return [2 /*return*/, cols.map(function (c) {
                            var label = c;
                            var lbType;
                            var prop = layerCate.colPrefix + '_' + c.toLowerCase();
                            var info = _this.appinfoService.columnMap[prop];
                            if (info) {
                                label = info.heading;
                                lbType = info.type;
                            }
                            var tooltip;
                            var require;
                            // let domains: any[];
                            // let domainPattern: string, domainRange: string;
                            var standardCol = layerCate.standardCols.find(function (s) { return s.colName.toLowerCase() === c.toLowerCase(); });
                            if (standardCol) {
                                tooltip = standardCol.htmlTooltip;
                                require = standardCol.require;
                                // const nenaList = this.editCardService.findNenaDomainValueListByColumn(c);
                                // if (nenaList && nenaList.length) {
                                // 	domains = nenaList;
                                // } else if (standardCol.valueDomainNameNct) {
                                // 	// // Hard code for county & cols nested
                                // 	// if (standardCol.valueDomainNameNct === 'COUNTY') {
                                // 	// 	domains = this.userService.customerInfo.cusCounties;
                                // 	// } else if (this.editCardService.nctDomainIndex['COUNTY'].child_nct_names.indexOf(standardCol.valueDomainNameNct.split(':')[0]) > -1) {
                                // 	// 	const stateValue = this.userService.customerInfo.givState;
                                // 	// 	const countyValue = this.userService.customerInfo.cusCounties[0];
                                // 	// 	const stateDomain = (<NctNestDomainListItem[]>this.editCardService.nctDomains['STATE'].list).find(i => i.value === stateValue);
                                // 	// 	const countyDomain = stateDomain ? (<NctNestDomainListItem[]>stateDomain.subDomain.list).find(i => i.value === countyValue) : null;
                                // 	// 	const currentDomain = countyDomain
                                // 	// } else {
                                // 		// should be direct under nctDomains (no nested domain)
                                // 		domains = this.editCardService.getNctDomainValueList(standardCol.valueDomainNameNct, this.editCardService.nctDomains[standardCol.valueDomainNameNct]);
                                // 	// }
                                // } else if (standardCol.valuePattern) {
                                // 	domainPattern = standardCol.valuePattern;
                                // }
                                // // else if (standardCol.valueRange) {
                                // // 	domainRange = standardCol.valueRange;
                                // // }
                            }
                            return {
                                prop: prop,
                                label: label || c,
                                lbType: lbType,
                                standardName: c,
                                htmlTooltip: tooltip,
                                // domains: domains,
                                // domainPattern: domainPattern,
                                // domainRange: domainRange,
                                require: require
                            };
                        })];
                }
            });
        });
    };
    ResolutionCenterService.prototype.transformItemList = function (resolverFeed, layerCateCode) {
        return __awaiter(this, void 0, void 0, function () {
            var itemList, currId, ids, currItem;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        itemList = [];
                        currId = resolverFeed.feed[layerCateCode].id;
                        ids = [currId];
                        if (resolverFeed.feed[layerCateCode].list) {
                            ids = ids.concat(resolverFeed.feed[layerCateCode].list);
                        }
                        // const returnedCols = cols.map(i => i.prop);
                        return [4 /*yield*/, this.getRecordsDetails(layerCateCode, ids)];
                    case 1:
                        // const returnedCols = cols.map(i => i.prop);
                        _a.sent();
                        currItem = {
                            id: currId,
                            props: this.recordsIndex[currId].props,
                            changedCols: this.recordsIndex[currId].changedCols,
                            isCurrent: true,
                            isSelectedInTable: true
                        };
                        itemList.push(currItem);
                        if (resolverFeed.feed[layerCateCode].list) {
                            resolverFeed.feed[layerCateCode].list.forEach(function (i) {
                                var addr = {
                                    id: i,
                                    props: _this.recordsIndex[i].props,
                                    // originalProps: rsp[idx] ? JSON.parse(JSON.stringify(rsp[idx])) : {},
                                    changedCols: _this.recordsIndex[i].changedCols
                                };
                                itemList.push(addr);
                            });
                        }
                        return [2 /*return*/, itemList];
                }
            });
        });
    };
    ResolutionCenterService.prototype.transformRules = function (rules) {
        if (!rules) {
            return [];
        }
        var filterOptions = this.mainDataService.qcFilterInfo.getValue().filterOptions || [];
        return rules.map(function (r) {
            var filterOption = filterOptions.find(function (f) { return f.value === r; });
            return {
                code: r,
                description: filterOption ? filterOption.descriptionLong : ''
            };
        });
    };
    ResolutionCenterService.prototype.onEditRecord = function (rec, col, isGeomChange) {
        console.log('onEdit');
        if (col && rec.changedCols.indexOf(col.prop) === -1) {
            rec.changedCols.push(col.prop);
        }
        if (isGeomChange && rec.changedCols.indexOf(this.attrIndexService.geomColManual) === -1) {
            rec.changedCols.push(this.attrIndexService.geomColManual);
            // rec.geomChange = true;
        }
    };
    ResolutionCenterService.prototype.commit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var changedRecordsByCateCode, updateGtos, gtos, editFilters, qcRsp;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        changedRecordsByCateCode = {};
                        Object.keys(this.recordsIndex).forEach(function (id) {
                            var cateCode = _this.recordsIndex[id].cateCode;
                            if (!changedRecordsByCateCode[cateCode]) {
                                changedRecordsByCateCode[cateCode] = [];
                            }
                            changedRecordsByCateCode[cateCode].push(_this.recordsIndex[id]);
                        });
                        gtos = [];
                        editFilters = [];
                        Object.keys(changedRecordsByCateCode).forEach(function (cateCode) {
                            var layerType = _this.appinfoService.layerTypeList.find(function (t) { return t.code === cateCode; });
                            if (!layerType || !layerType.tableName) {
                                console.log('Can not find source table');
                                return;
                            }
                            var sourceTableName = layerType.tableName;
                            var prefix = layerType.colPrefix;
                            var primKeyCol;
                            primKeyCol = _this.editService.getPrimKeyCol(prefix);
                            var idCol = _this.getGlobalIdCol(cateCode);
                            var changedCols = [];
                            var updateRecords = [];
                            var updateRecordsOrigin = [];
                            changedRecordsByCateCode[cateCode].forEach(function (i) {
                                if (!i.changedCols.length) {
                                    // if (!i.changedCols.length && !i.geomChange) {
                                    return;
                                }
                                i.changedCols.forEach(function (c) {
                                    if (changedCols.indexOf(c) === -1) {
                                        changedCols.push(c);
                                    }
                                });
                                updateRecords.push(i.props);
                                updateRecordsOrigin.push(_this.recordsIndex[i.props[idCol]].originalProps);
                            });
                            var dynamicQcKeyvals = [];
                            var colsAll = _this.editService.getUpdateColsInSourceTable(sourceTableName, prefix);
                            if (updateRecords.length) {
                                updateRecords.forEach(function (r) {
                                    var id = r[idCol];
                                    if (dynamicQcKeyvals.indexOf(id) === -1) {
                                        dynamicQcKeyvals.push(id);
                                    }
                                    if (_this.recordsIndex[id].relatedIdList) {
                                        _this.recordsIndex[id].relatedIdList.forEach(function (id) {
                                            if (dynamicQcKeyvals.indexOf(id) === -1) {
                                                dynamicQcKeyvals.push(id);
                                            }
                                        });
                                    }
                                });
                                // Use archive mode for resolution center commits
                                var updateGtosInfo = _this.editService.getUpdateGtosByRecordsArchive(colsAll, updateRecords, updateRecordsOrigin, sourceTableName, prefix, primKeyCol, _this.attrIndexService.geomColManual);
                                updateGtos = updateGtosInfo.gtos;
                                changedCols = updateGtosInfo.changedCols;
                                changedCols = changedCols
                                    // .map(changedCol => {
                                    // 	// remove prefix
                                    // 	return changedCol.substring(4); // TODO
                                    // })
                                    .filter(function (c) { return c; });
                                gtos = gtos.concat(updateGtos);
                                var layerId = _this.layerService.layerListBS.getValue().layers.find(function (l) { return l.category.code === cateCode && l.maintainType === 'LIVE'; }).id;
                                var editFilter = {
                                    gly_id: layerId,
                                    cols: changedCols,
                                    keyvals: dynamicQcKeyvals
                                };
                                editFilters.push(editFilter);
                            }
                        });
                        if (!gtos.length) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.gtoService.processGto(gtos)];
                    case 1:
                        _a.sent();
                        this.toastr.success('Successfully updated.');
                        return [4 /*yield*/, this.qcService.qcLayersDynamic(editFilters)];
                    case 2:
                        qcRsp = _a.sent();
                        // if (qcRsp.misc && qcRsp.misc.transition > 0) {
                        // 	this.qcService.qcLayers(selectedLayer.id);
                        // } else {
                        this.activityService.refreshData.next({
                            updateLayerList: true,
                            updateSchema: true // filter option counts need to be updated // false
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Metrics
    ResolutionCenterService.prototype.calcAddressDensity = function (recordProps, geomLength, side) {
        var leftDensity, rightDensity;
        if (geomLength) {
            var getDensity = function (from, to) {
                var fromNum = from ? Number(from) : (from === 0 ? from : null);
                var toNum = to ? Number(to) : (to === 0 ? to : null);
                if (fromNum === null || toNum === null || !geomLength) {
                    return null;
                }
                // return Number(((toNum - fromNum) / geomLength).toFixed(2));
                return Number((Math.abs(fromNum - toNum) / (geomLength + 1) / 0.000621371).toFixed(1));
            };
            if (!side || side === 'left') {
                leftDensity = getDensity(recordProps[this.attrIndexService.fromAddrLeftColName], recordProps[this.attrIndexService.toAddrLeftColName]);
            }
            if (!side || side === 'right') {
                rightDensity = getDensity(recordProps[this.attrIndexService.fromAddrRightColName], recordProps[this.attrIndexService.toAddrRightColName]);
            }
        }
        return {
            left: leftDensity,
            right: rightDensity
        };
    };
    ResolutionCenterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ResolutionCenterService_Factory() { return new ResolutionCenterService(i0.ɵɵinject(i1.ToastrService), i0.ɵɵinject(i2.ActivityService), i0.ɵɵinject(i3.AppinfoService), i0.ɵɵinject(i4.ArchiveModeService), i0.ɵɵinject(i5.AttrIndexService), i0.ɵɵinject(i6.CommonRequestService), i0.ɵɵinject(i7.EditService), i0.ɵɵinject(i8.FieldMappingService), i0.ɵɵinject(i9.GfoService), i0.ɵɵinject(i10.GtoService), i0.ɵɵinject(i11.LayerService), i0.ɵɵinject(i12.LayerQcService), i0.ɵɵinject(i13.MainDataService), i0.ɵɵinject(i14.UserService)); }, token: ResolutionCenterService, providedIn: "root" });
    return ResolutionCenterService;
}());
export { ResolutionCenterService };
